import { Registry } from "@react-registry"

export const BLOCKQUOTE = () => {
    return {
        type: 'blockquote'
    }
}

Registry.register(BLOCKQUOTE, { id: 'BLOCKQUOTE', registry: 'deserializer' })